import { render, staticRenderFns } from "./TodayApplicants.vue?vue&type=template&id=4b825594"
import script from "./TodayApplicants.vue?vue&type=script&lang=js"
export * from "./TodayApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports